
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import delphiLogo from '@/assets/delphi-logo.png.asset.json';

const navItems = [{
  name: 'Research',
  path: '/research'
}, {
  name: 'Performance Record',
  path: '/performance'
}, {
  name: 'Managing Partners',
  path: '/partners'
}, {
  name: 'See for Yourself',
  path: '/contact'
}];

// Temporarily hidden nav items (kept for future re-enable):
// { name: 'Trading Philosophy', path: '/trading-philosophy' }
// { name: "What's Next?", path: '/whats-next' }

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  
  return (
    <nav className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${scrolled ? 'bg-delphi-dark/95 backdrop-blur' : 'bg-transparent'}`}>
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center shrink-0">
            <img src={delphiLogo.url} alt="DEL(PHI) Technologies Logo" className="h-12 w-auto" />
          </Link>
          
          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center flex-1 justify-center ml-12">
            <div className="flex items-center justify-evenly w-full max-w-4xl">
              {navItems.map(item => (
                <Link 
                  key={item.name} 
                  to={item.path} 
                  className={`text-sm font-medium transition-colors hover:text-delphi-red whitespace-nowrap ${
                    location.pathname === item.path ? 'text-delphi-red' : 'text-delphi-light'
                  }`}
                >
                  {item.name}
                </Link>
              ))}
            </div>
          </div>
          
          <Link 
            to="/partner-login" 
            className="hidden md:inline-block px-4 py-2 text-center text-sm font-medium bg-delphi-red text-white rounded hover:bg-red-600 transition-all shrink-0 ml-6"
          >
            Partner Login
          </Link>
          
          {/* Mobile Navigation Toggle */}
          <button 
            className="md:hidden text-delphi-light hover:text-delphi-red transition" 
            onClick={() => setIsOpen(!isOpen)} 
            aria-label="Toggle Menu"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
      
      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-delphi-dark/95 backdrop-blur shadow-lg absolute top-16 left-0 w-full py-4 animate-fade-in">
          <div className="container mx-auto px-4 flex flex-col space-y-4">
            {navItems.map(item => (
              <Link 
                key={item.name} 
                to={item.path} 
                className={`text-lg font-medium transition-colors hover:text-delphi-red ${
                  location.pathname === item.path ? 'text-delphi-red' : 'text-delphi-light'
                }`} 
                onClick={() => setIsOpen(false)}
              >
                {item.name}
              </Link>
            ))}
            <Link 
              to="/partner-login" 
              className="w-full px-4 py-2 text-center text-sm font-medium bg-delphi-red text-white rounded hover:bg-red-600 transition-all" 
              onClick={() => setIsOpen(false)}
            >
              Partner Login
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
